import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SmartLeadPrompt from "./SmartLeadPrompt";
import CropFocusInspector from "./dev/CropFocusInspector";

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="relative flex min-h-screen w-full max-w-none flex-col overflow-x-clip">
    {/* Global atmospheric warmth — continuous light from top.
        Mobile (<md) skips the blur(100–140px) layers — they're GPU-expensive
        on low-power devices and barely visible at small viewports. The warm
        wash + bottom warmth still ship on every screen for brand continuity. */}
    <div className="pointer-events-none fixed inset-0 z-0">
      {/* Top warm wash — cinematic light spill from above */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[140%] h-[800px] bg-[radial-gradient(ellipse_at_top_center,hsl(32_35%_52%_/_0.035)_0%,hsl(32_35%_52%_/_0.012)_40%,transparent_70%)]" />
      {/* Left ambient glow — warm side light (desktop-only, heavy blur) */}
      <div className="hidden md:block absolute top-[20%] -left-[8%] w-[600px] h-[1000px] bg-[radial-gradient(ellipse_at_center,hsl(32_35%_52%_/_0.02)_0%,transparent_65%)] blur-[120px]" />
      {/* Right ambient glow — cooler, subtler (desktop-only, heavy blur) */}
      <div className="hidden md:block absolute top-[45%] -right-[8%] w-[500px] h-[800px] bg-[radial-gradient(ellipse_at_center,hsl(25_20%_18%_/_0.012)_0%,transparent_65%)] blur-[100px]" />
      {/* Center depth pool — creates a soft luminance valley (desktop-only, heavy blur) */}
      <div className="hidden md:block absolute top-[35%] left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[radial-gradient(ellipse_at_center,hsl(32_35%_52%_/_0.015)_0%,transparent_55%)] blur-[140px]" />
      {/* Bottom warmth — cinematic fade toward footer */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[130%] h-[500px] bg-[radial-gradient(ellipse_at_bottom_center,hsl(25_20%_18%_/_0.025)_0%,transparent_65%)]" />
    </div>
    <Navbar />
    <main className="flex-1 relative z-[1]">{children}</main>
    <SmartLeadPrompt />
    <Footer />
    <CropFocusInspector />
  </div>
);

export default Layout;
